import { render, staticRenderFns } from "./EzCareToggle.vue?vue&type=template&id=64a9c760"
import script from "./EzCareToggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./EzCareToggle.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports